import { CssBaseline, ThemeProvider } from '@mui/material'
import { theme } from './config'
import {
    AuthProvider,
    ConnectionProvider,
    ExecutionReportProvider,
    LanguageProvider,
    Machine3DProvider,
    MachineProvider,
    NavigationProvider,
    ReportsProvider,
    SitesProvider,
    SystemProvider,
    TimeProvider,
    UsersProvider,
    ContextComposer,
    AlertProvider,
    NotificationsProvider,
    LoadingProvider,
    UserProvider,
    SignatureProvider,
    MasterDataProvider
} from './context'
import { Notifications } from 'react-push-notification'
import { StatusProvider } from './context/Status.context'

const AppProviders = ({ children }) => {
    return (
        <ContextComposer contexts={[
            <ThemeProvider key="theme" theme={theme} />,
            <AlertProvider key="alert" />,
            <LoadingProvider key="loading" />,
            <ConnectionProvider key="connection" />,
            <AuthProvider key="auth" />,
            <UserProvider key="user" />,
            <SignatureProvider key="signature" />,
            <MasterDataProvider key="masterdata" />,
            <StatusProvider key="status" />,
            <NotificationsProvider key="notifications" />,
            <SitesProvider key="sites" />,
            <LanguageProvider key="language" />,
            <NavigationProvider key="navigation" />,
            <UsersProvider key="users" />,
            <ReportsProvider key="reports" />,
            <ExecutionReportProvider key="execution" />,
            <TimeProvider key="time" />,
            <MachineProvider key="machine" />,
            <Machine3DProvider key="machine3d" />,
            <SystemProvider key="system" />
        ]}>
            <CssBaseline />
            <Notifications />
            {children}
        </ContextComposer>
    )
}

export default AppProviders
